module.exports = __webpack_public_path__ + "img/yiwancheng.066589d5.png";